// extracted by mini-css-extract-plugin
export default {"changePasswordForm":"changePasswordForm---k9qQM"};